import { SsoMappingField } from 'graphql-common';
import Collapse from '@lib/components/Collapse/Collapse';
import Typography from '@lib/components/Typography/Typography';
import styles from '../SsoIntegrationView.module.scss';

interface Props {
  attributeMapping?: string | Record<string, unknown> | null;
  supportedMappingFields?: SsoMappingField[];
}

const COLLAPSE_MIN_HEIGHT = 24;

export default function AttributeMappingDisplay({
  attributeMapping,
  supportedMappingFields,
}: Props) {
  if (!attributeMapping) {
    return <Typography variant="body">-</Typography>;
  }

  let mappings: [string, string][] = [];
  if (typeof attributeMapping === 'object') {
    mappings = Object.entries(attributeMapping).map(([key, value]) => [
      key,
      String(value),
    ]);
  } else {
    try {
      const parsed = JSON.parse(attributeMapping);
      mappings = Object.entries(parsed).map(([key, value]) => [
        key,
        String(value),
      ]);
    } catch {
      return <Typography variant="body">{attributeMapping}</Typography>;
    }
  }

  if (supportedMappingFields?.length) {
    const fieldOrder = new Map(
      supportedMappingFields.map((f) => [f.key, f.sortIndex]),
    );
    mappings.sort(
      ([, av], [, bv]) =>
        (fieldOrder.get(av) ?? Infinity) - (fieldOrder.get(bv) ?? Infinity),
    );
  }

  if (mappings.length === 0) {
    return <Typography variant="body">-</Typography>;
  }

  return (
    <Collapse minHeight={COLLAPSE_MIN_HEIGHT}>
      <div className={styles.attributeList}>
        {mappings.map(([key, value]) => (
          <Typography key={key} variant="body">
            {key} → {value}
          </Typography>
        ))}
      </div>
    </Collapse>
  );
}
